(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["worthy-navigation-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  const dock = document.querySelector('[data-worthy-dock]');
  if (!dock) return;
  const top = dock.querySelector('[data-worthy-top]');
  const wrapper = document.querySelector('.page-wrapper');
  const scroller = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : document.scrollingElement;
  const update = () => {
    top.hidden = scroller.scrollTop < 240;
    dock.hidden = !dock.querySelector('[data-worthy-back]') && top.hidden;
  };
  window.addEventListener('scroll', update, { passive: true });
  scroller.addEventListener('scroll', update, { passive: true });
  window.addEventListener('pageshow', update);
  update();
  top.addEventListener('click', () => {
    const main = document.getElementById('MainContent');
    if (main) { main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
    scroller.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-worthy-back]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let previous;
    try { previous = new URL(document.referrer); } catch (_) { return; }
    if (previous.origin === location.origin && previous.pathname !== location.pathname && history.length > 1) {
      event.preventDefault();
      history.back();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
